export enum Events {
	SKIP_ANIMATION = "SKIP_ANIMATION",
	ANIMATION_FINISHED = "ANIMATION_FINISHED",
	TEXT_CHANGE = "TEXT_CHANGE",
	RESTART_GAME = "RESTART_GAME"
}
